import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Admin } from "@/api/auth/auth.ts";
import { ChangeLogRecord } from "@/api/change-logs";

interface UserState {
  currentUser: Partial<Admin>;
  permissions: number;
  tour: {
    stepIndex: number;
    run: boolean;
    isTourActive: boolean;
  };
  modals: {
    changeLog: {
      isOpen: boolean;
      records: ChangeLogRecord[];
    };
  };
}

const initialState: UserState = {
  currentUser: {
    first_name: "Not",
    last_name: "Loaded",
  },
  permissions: 0,
  tour: {
    stepIndex: 0,
    run: false,
    isTourActive: true,
  },
  modals: {
    changeLog: {
      isOpen: false,
      records: [],
    },
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<Admin>) {
      state.currentUser = action.payload;
    },
    setPermissions(state, action: PayloadAction<number>) {
      state.permissions = action.payload;
    },
    setTour(state, action: PayloadAction<Partial<UserState["tour"]>>) {
      state.tour = {
        ...state.tour,
        ...action.payload,
      };
    },
    setChangeLogModal(state, action: PayloadAction<boolean>) {
      state.modals.changeLog.isOpen = action.payload;
    },
    setChangeLogRecords(state, action: PayloadAction<ChangeLogRecord[]>) {
      state.modals.changeLog.records = action.payload.sort(
        (a, b) => b.id - a.id,
      );
    },
  },
});

export const {
  setUser,
  setPermissions,
  setTour,
  setChangeLogModal,
  setChangeLogRecords,
} = userSlice.actions;

export default userSlice.reducer;
